export default __webpack_public_path__ + "static/media/G_Gelo.3847ed81.svg";